import { render, staticRenderFns } from "./UpsellProducts.vue?vue&type=template&id=5312ace3&"
import script from "./UpsellProducts.vue?vue&type=script&lang=ts&"
export * from "./UpsellProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports